import { render, staticRenderFns } from "./TemplatePermissionsChips.vue?vue&type=template&id=f683aca2&scoped=true"
import script from "./TemplatePermissionsChips.vue?vue&type=script&lang=js"
export * from "./TemplatePermissionsChips.vue?vue&type=script&lang=js"
import style0 from "./TemplatePermissionsChips.vue?vue&type=style&index=0&id=f683aca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f683aca2",
  null
  
)

export default component.exports